class NewsletterPopupOnScroll extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables

	}

	init() {

        this.form = new Me.form(this.$('form'), {
            form_scope: this,
            fields: [
                {name: 'email'},
                {name: 'restaurant_name', required: true}
            ],
            onSuccess: this.formSuccessHandler,
            onValidationSuccess: $.proxy(this.formValidationSuccessHandler, this),
            onError: this.formErrorHandler,
        });

        this.addEvents();
	}

	addEvents() {
        Me.dispatch.subscribe('modal-content-deleted', (e, params) => this.registerCookie(e, params));
    }

    displaySubscriptionError(){
        this.$('.error-message').addClass('hide');
        this.$('.error-message.subscribed').removeClass('hide');
    }

    formErrorHandler(error){
	    console.log('error');
        this.$('.error-message').addClass('hide');
        this.$('.error-message.error').removeClass('hide');
    }

    formSuccessHandler(e, data){
        this.$('.error-message').addClass('hide');
        this.$('.error-message.success').removeClass('hide');

        // this.form.reset();

        Me.track.event("Newsletter", "Subscribe");
        fbq('track', 'CompleteRegistration');
    }

    formValidationSuccessHandler(){
        $.ajax({
            cache: false,
            url: this.$('form').attr('data-service-url')
                .replace('[Email]', this.$('input.user-email').val())
                .replace('[StoreNumber]', this.$('#restaurant_name option[selected]').val())
                .replace('[StoreName]', this.$('#restaurant_name option[selected]').attr('data-name'))
                .replace('[StoreCity]', this.$('#restaurant_name option[selected]').attr('data-city'))
                .replace('[StorePhone]', this.$('#restaurant_name option[selected]').attr('data-phone'))
                .replace('[StoreURL]', this.$('#restaurant_name option[selected]').attr('data-store-url'))
                .replace('[StoreAddress]', this.$('#restaurant_name option[selected]').attr('data-address')),
            success: $.proxy(this.formSuccessHandler, this),
            error: $.proxy(this.formErrorHandler, this)
        });
	}

    registerCookie(e, params){

        if(params.name == 'newsletter-popup-onscroll'){
            Cookies.set('newsletter-pizzadelight-onscroll', true);
        }
    }

    removeEvents() {
        Me.dispatch.unsubscribe('modal-content-deleted', (e, params) => this.registerCookie(e, params));
    }

    scrollHandler(e){
        if($('html').scrollTop() > 100 && this.$('input').val() == ''){
            $(window).off('scroll');
            Me.dispatch.emit('close-modal');
        }
    }
}